module.exports = __webpack_public_path__ + "static/image4-b610b358c72306b916e1bfa8b9ff8ec0.jpg";